<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Adrian Lee Baker lives in a small village outside Ashby-de-la-Zouch, Leicestershire. He is fifty-three years old, married to Angela and has two daughters, Phoebe and Milly. His occupation is in teaching and works as a lecturer and trainer-assessor in further education. He likes country walking, mountain biking and is a Second Dan in the combat sport of kick-boxing. It has always been his ambition to write and have something published. He is an avid fan of both books and films, especially of the sci-fi and horror genres, and latterly, dark fantasy. Hence his writing style reflects the darker side of life. Favourite books include <em>Nineteen Eighty-Four</em>, <em>A Clockwork Orange</em>, <em>Heart of Darkness</em>, <em>Dracula</em>, <em>Naked Lunch</em>, and <em>Fear and Loathing in Las Vegas</em>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?bc3f98d4